import { NotificationsList } from "./NotificationsList";

export default { list: NotificationsList };
